import React from 'react';
import PostSendModal from '../PostSendModal/PostSendModal';
import { Icon } from '@landing/ui';
import { defaultModalsId } from '../constants';

import * as styles from './SuccessModal.module.scss';

export default function SuccessModal() {
  const icon = () => <Icon name="letter-success" className={styles.icon} />;

  return (
    <PostSendModal Icon={icon} modalID={defaultModalsId.successModal}>
      <div className={styles.wrapper}>
        <p className={styles.text}>
          {"Sorry, we are fully booked and don't accept new registrations."}
        </p>
        <p className={styles.text}>
          {"We'll put you in the waitlist and notify if a slot gets available."}
        </p>
      </div>
    </PostSendModal>
  );
}
